
// 设置页
const setting = () => import(/* webpackChunkName: "Index" */ '@/views/settingModule/index')

const settingRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/setting',
          name: 'setting',
          redirect: '/admin/setting/quarters',
          component: setting,
          meta: {
            title: '设置'
          },
          children: [
            {
              path: '/admin/setting/quarters',
              name: 'settingQuarters',
              component: () => import('@/views/settingModule/addQuarters'),
              meta: {
                title: '设置'
              },
            },
            {
              path: '/admin/setting/goods',
              name: 'settingGoods',
              component: () => import('@/views/settingModule/addGoods'),
              meta: {
                title: '设置'
              },
            },
            {
              path: '/admin/setting/media',
              name: 'settingMedia',
              component: () => import('@/views/settingModule/addMedia'),
              meta: {
                title: '设置'
              },
            },
            {
              path: '/admin/setting/terrace',
              name: 'settingTerrace',
              component: () => import('@/views/settingModule/addTerrace'),
              meta: {
                title: '设置'
              },
            },
            {
              path: '/admin/setting/tally',
              name: 'settingTally',
              component: () => import('@/views/settingModule/addTally'),
              meta: {
                title: '设置'
              },
            },
            {
              path: '/admin/setting/brand',
              name: 'settingBrand',
              component: () => import('@/views/settingModule/addBrand'),
              meta: {
                title: '设置'
              },
            },
            {
              path: '/admin/setting/industry',
              name: 'settingIndustry',
              component: () => import('@/views/settingModule/addIndustry'),
              meta: {
                title: '设置'
              },
            },
            {
              path: '/admin/setting/projectType',
              name: 'settingProjectType',
              component: () => import('@/views/settingModule/addProjectType'),
              meta: {
                title: '设置'
              },
            }
          ]
        }
      ]
    }
  ]
  export default settingRouter
  
